import { mapGetters, mapActions, mapMutations } from "vuex";
import { dynamicHead } from "../../mixins/dynamic-head";
export default {
    name: "agent-info",
    mixins: [dynamicHead],
    created() {
        this.getSeoData("agent-info").then(() => {
            this.setPageItem(this.seoData);
        });
        if (!this.agentItems) {
            this.fetchAgentItem();
        }
        if (!this.agentInstruction) {
            this.fetchAgentInstruction();
        }
    },
    computed: {
        ...mapGetters({
            agentItems: "agentInfo/agentItem",
            agentInstruction: "agentInfo/agentInstruction",
            seoData: "setting/seoData",
        }),
    },
    methods: {
        ...mapMutations({
            setAgentItem: "agentInfo/SET_AGENT_INFO",
            changePopupRegisterAgent: `auth/CHANGE_POPUP_REGISTER_AGENT`,
        }),
        ...mapActions({
            fetchAgentItem: `agentInfo/GET_AGENT_INFO`,
            fetchAgentInstruction: `agentInfo/GET_AGENT_INSTRUCTION`,
            getSeoData: "setting/GET_SEO_DATA",
        }),
    },
};
